import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M11.011 18.595c-1.991 0-3.705-.718-5.142-2.155-1.437-1.437-2.155-3.15-2.155-5.142V10.27l-1.825 1.825-.889-.89 3.398-3.398 3.605 3.398-.89.89-2.03-1.84v1.042c0 1.626.58 3.021 1.744 4.184 1.163 1.163 2.558 1.745 4.184 1.745.441 0 .86-.038 1.255-.114.395-.076.767-.19 1.117-.342l.98.98a6.385 6.385 0 0 1-1.653.65 7.468 7.468 0 0 1-1.699.194Zm6.591-3.854-3.628-3.398.912-.912 2.032 1.847v-.98c0-1.627-.582-3.022-1.745-4.185-1.163-1.163-2.558-1.745-4.184-1.745-.441 0-.86.042-1.255.126a9.19 9.19 0 0 0-1.117.308l-.98-.981a6.084 6.084 0 0 1 1.653-.639A7.912 7.912 0 0 1 10.989 4c1.991 0 3.705.718 5.142 2.155 1.437 1.437 2.155 3.151 2.155 5.143v.98l1.825-1.824.889.89-3.398 3.397Z" />
  </svg>
);
